export enum SubscriptionPlan {
  FREE = 'FREE',
  PROFESSIONAL = 'PROFESSIONAL',
  ENTERPRISE = 'ENTERPRISE',
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  TRIALING = 'TRIALING',
  PAST_DUE = 'PAST_DUE',
  CANCELED = 'CANCELED',
  PAUSED = 'PAUSED',
}

export interface PlanLimits {
  organizations: number;
  projects: number;
  scansPerMonth: number;
  apiCallsPerDay: number;
  features: {
    bulkUpload: boolean;
    apiAccess: boolean;
    customSchedules: boolean;
    prioritySupport: boolean;
    whiteLabel: boolean;
    sso: boolean;
    onPremise: boolean;
    advancedCompliance: boolean;
    emailAlerts: boolean;
    historicalAnalysis: boolean;
  };
}

export const PLAN_LIMITS: Record<SubscriptionPlan, PlanLimits> = {
  [SubscriptionPlan.FREE]: {
    organizations: 1,
    projects: 5,
    scansPerMonth: 10,
    apiCallsPerDay: 0,
    features: {
      bulkUpload: false,
      apiAccess: false,
      customSchedules: false,
      prioritySupport: false,
      whiteLabel: false,
      sso: false,
      onPremise: false,
      advancedCompliance: false,
      emailAlerts: false,
      historicalAnalysis: false,
    },
  },
  [SubscriptionPlan.PROFESSIONAL]: {
    organizations: 5,
    projects: -1, // unlimited
    scansPerMonth: 100,
    apiCallsPerDay: 10000,
    features: {
      bulkUpload: true,
      apiAccess: true,
      customSchedules: true,
      prioritySupport: true,
      whiteLabel: false,
      sso: false,
      onPremise: false,
      advancedCompliance: true,
      emailAlerts: true,
      historicalAnalysis: true,
    },
  },
  [SubscriptionPlan.ENTERPRISE]: {
    organizations: -1, // unlimited
    projects: -1, // unlimited
    scansPerMonth: -1, // unlimited
    apiCallsPerDay: -1, // unlimited
    features: {
      bulkUpload: true,
      apiAccess: true,
      customSchedules: true,
      prioritySupport: true,
      whiteLabel: true,
      sso: true,
      onPremise: true,
      advancedCompliance: true,
      emailAlerts: true,
      historicalAnalysis: true,
    },
  },
};

export interface PlanPricing {
  plan: SubscriptionPlan;
  name: string;
  monthlyPrice: number | null; // null for custom pricing
  yearlyPrice: number | null;
  currency: string;
  trialDays: number;
}

export const PLAN_PRICING: Record<SubscriptionPlan, PlanPricing> = {
  [SubscriptionPlan.FREE]: {
    plan: SubscriptionPlan.FREE,
    name: 'Starter',
    monthlyPrice: 0,
    yearlyPrice: 0,
    currency: 'EUR',
    trialDays: 0,
  },
  [SubscriptionPlan.PROFESSIONAL]: {
    plan: SubscriptionPlan.PROFESSIONAL,
    name: 'Professional',
    monthlyPrice: 299,
    yearlyPrice: 2868, // 20% discount
    currency: 'EUR',
    trialDays: 14,
  },
  [SubscriptionPlan.ENTERPRISE]: {
    plan: SubscriptionPlan.ENTERPRISE,
    name: 'Enterprise',
    monthlyPrice: null,
    yearlyPrice: null,
    currency: 'EUR',
    trialDays: 30,
  },
};
